export const LIST_FORMATTER = new Intl.ListFormat("en", {
  style: "long",
  type: "conjunction",
});

export const LIST_FORMATTER_SHORT = new Intl.ListFormat("en", {
  style: "short",
  type: "conjunction",
});

export const groupBy = <T extends Record<string, object>, K extends keyof T>(
  array: T[],
  key: K,
): Record<string, T[]> => array.reduce((result, item) => {
  const groupKey = String(item[key] as unknown);
  if (!result[groupKey]) {
    result[groupKey] = []; // eslint-disable-line
  }
  result[groupKey].push(item);
  return result;
}, {} as Record<string, T[]>);
